import axios from 'axios'

export const APIURL = process.env.REACT_APP_API_URL

// SSO handoff: the auth app posts { public_key, private_key }.
export function login_with_user_module(data) {
	return axios.post(APIURL + '/auth/login_with_user_module', data)
}

// Direct email/password login (Single Login v2).
export function login_with_email_and_password(data) {
	return axios.post(APIURL + '/auth/login_with_email_and_password', data)
}

// Business-selection step: { token: selectionToken, business_id: businessUuid }.
export function login_to_business_with_token(data) {
	return axios.post(APIURL + '/auth/login_to_business_with_token', data)
}

// SSO token handoff from the v2 auth app: { token, business_id }.
export function verify_sso_token(data) {
	return axios.post(APIURL + '/auth/verify_sso_token', data)
}

export function login_using_keys(data) {
	return axios.post(APIURL + '/auth/login_using_keys', data)
}

export function login_using_refresh_token(data) {
	return axios.post(APIURL + '/auth/login_using_refresh_token', data)
}

export function confirm_token() {
	return axios.get(APIURL + '/')
}
